<template>
  <main class="container-fluid">
    <form class="form" :class="{
      'section-loading': loading
    }">
      <h3>新增客戶</h3>
      <h4 class="text-green mb-4">基本資料</h4>
      <div class="form-group">
        <label for="name">
          姓名
          <span class="waring-block d-inline-block">
            <span class="text"><span class="text-red">＊</span>必填</span>
          </span>
        </label>
        <input type="text" id="name" class="form-control"
        v-model="form.name"
        placeholder="請輸入真實姓名" alt="ch">
      </div>
      <div class="form-group">
        <label for="identity-id">ID</label>
        <input type="text" id="identity-id" class="form-control"
        v-model="form.identityID"
        placeholder="請輸入身分證字號">
        <!-- <div class="invalid-feedback">
          此ID格式有誤
        </div> -->
      </div>
      <h4 class="text-green mb-4">
        聯絡資訊
        <span class="waring-block d-inline-block">
          <span class="text"><span class="text-red">＊</span>聯絡資訊為必填，請擇一填寫</span>
        </span>
      </h4>
      <div class="form-group">
        <label for="line-id">LINE ID</label>
        <input type="text" id="line-id" class="form-control"
        v-model="form.lineid"
        placeholder="請輸入 LINE ID">
      </div>
      <div class="form-group">
        <label for="mobile">手機</label>
        <input type="tel" id="mobile" class="form-control"
        @input="numberMobile"
        v-model="form.mobile"
        placeholder="例如：0912345678">
      </div>
      <div class="form-group">
        <label for="phone">住家電話</label>
        <input type="tel" id="phone" class="form-control form-control-inline form-short"
        @input="numberPhone0"
        v-model="form.phone[0]"
        placeholder="區碼">
        <span class="text">-</span>
        <input type="tel" class="form-control form-control-inline"
        @input="numberPhone1"
        v-model="form.phone[1]"
        placeholder="電話號碼">
      </div>
      <div class="form-group">
        <label for="office">公司電話</label>
        <input type="tel" id="office" class="form-control form-control-inline form-short"
        @input="numberOffice_phone0"
        v-model="form.office_phone[0]"
        placeholder="區碼">
        <span class="text">-</span>
        <input type="tel" class="form-control form-control-inline"
        @input="numberOffice_phone1"
        v-model="form.office_phone[1]"
        placeholder="電話號碼">
        <span class="text">-</span>
        <input type="tel" id="office" class="form-control form-control-inline form-short"
        @input="numberOffice_phone2"
        v-model="form.office_phone[2]"
        placeholder="分機">
      </div>
      <div class="action two-buttons mt-5">
        <button type="reset" @click="doReset()" class="btn btn-default">清空資料</button>
        <button type="button"
        class="btn btn-primary"
        @click="doSubmit()">新增客戶</button>
      </div>
    </form>

    <warning-modal
    :message="'此客戶已存在，請確認必填欄位是否重複'"
    :open="warningModalOpen"
    @close="panelClose('warningModalOpen')"/>

  </main>
</template>

<script>
import {mapActions} from 'vuex'
import WarningModal from '../components/WarningModal.vue'
import {commonMixin} from '../../mixins/common'
import {addNewCust} from '@/service'

export default {
  name: 'CustomerCreate',
  mixins: [commonMixin],
  components: { WarningModal },
  data () {
    return {
      isValid: false,
      warningModalOpen: false,
      loading: false,
      form: {
        name: '',
        identityID: '',
        birthday: ['', '',''],
        gender: '',
        lineid: '',
        mobile: '',
        phone: ['', ''],
        office_phone: ['', '', ''],
        fax_area: '',
        fax: '',
        email: '',
        introducer: '',
        introducerId: '',
        career: '',
        education: '',
        agency: '',
        marriage: '',
        address: ['', '', '', ''],
        office_address: ['', '', '', ''],
        household_income: '',
        personal_income: '',
        houseloan: '',
        housing: '',
        monthly_invest: '',
        finance_tool: [],
        vehicle: '',
        group: [], 
        wg_name: ''
      }
    }
  },
  methods: {
    ...mapActions([
      'setPageLock','updateSerNo','updateCustID'
    ]),

    //  監聽input 只能輸入數字
    numberMobile(){
      this.form.mobile = this.form.mobile.replace(/[^\d]/g,'');
    },
    numberPhone0(){
      this.form.phone[0] = this.form.phone[0].replace(/[^\d]/g,'');
    },
    numberPhone1(){
      this.form.phone[1] = this.form.phone[1].replace(/[^\d]/g,'');
    },
    numberOffice_phone0(){
      this.form.office_phone[0] = this.form.office_phone[0].replace(/[^\d]/g,'');
    },
    numberOffice_phone1(){
      this.form.office_phone[1] = this.form.office_phone[1].replace(/[^\d]/g,'');
    },
    numberOffice_phone2(){
      this.form.office_phone[2] = this.form.office_phone[2].replace(/[^\d]/g,'');
    },
    checkName() {
      // 不能空 也不能為特殊符號
      let pattern = /[<>!@\$\^&,\."'\?%\*\(\)\+\/\{\}\[\]\|~`=\s]/g
      let isNonEmpty = this.form.name.trim().length > 0
      let isFormatCurrect = (this.form.name.match(pattern) == null)
      return isNonEmpty && isFormatCurrect
      // return true
    },
    checkLine() {
      if(this.form.lineid == '') { return true } 
      let linePattern = /^[A-Za-z0-9_\-\.]+$/
      return linePattern.test(this.form.lineid)
    },
    checkMobile() {
      if(this.form.mobile == '') { return true } 
      let mobilePattern = new RegExp('^[0-9]{10}$')
      return mobilePattern.test(this.form.mobile)
    },
    checkPhone(target) {
      let phoneAreaPattern = new RegExp('^0[0-9]{1,3}$')
      let phonePattern = new RegExp('^[0-9]{7,10}$')
      let extPattern = /^[0-9]{0,8}$/
      switch (target) {
        case 'home':
          if(this.form.phone[0] == '' && this.form.phone[1] == '') { return true } 
          return phoneAreaPattern.test(this.form.phone[0]) && phonePattern.test(this.form.phone[1])
        case 'office':
          if(this.form.office_phone[0] == '' && this.form.office_phone[1] == '' && this.form.office_phone[2] == '') { return true } 
          return phoneAreaPattern.test(this.form.office_phone[0]) && phonePattern.test(this.form.office_phone[1]) && extPattern.test(this.form.office_phone[2])
        default:
          return false
      }
    },  
    checkWordNum(){
      // 判斷輸入欄位字數是否超過限制
      if(this.form.name.length > 50 ||  this.form.identityID.length > 10 || this.form.lineid.length > 20 || this.form.mobile.length >20 ||
      this.form.phone[0].length > 5 || this.form.phone[1].length > 20 || this.form.office_phone[0].length > 5 ||
      this.form.office_phone[1].length > 15 || this.form.office_phone[2].length > 10 ){
        return false
      }else{
        return true
      }
    },
    checkContactInfoIsAllEmpty () {
      let isLineEmpty = this.form.lineid == ''
      let isMobileEmpty = this.form.mobile == ''
      let isPhoneEmpty = this.form.phone[0] == '' && this.form.phone[1] == ''
      let isOfficePhoneEmpty = this.form.office_phone[0] == '' && this.form.office_phone[1] == '' && this.form.office_phone[2] == ''
      return isLineEmpty && isMobileEmpty && isPhoneEmpty && isOfficePhoneEmpty
    },    
    doSubmit () { 
      if(!this.checkWordNum()){
        return this.$toast.info({title: '欄位總字數超過限制'})
      }
      let checkNameMsg = this.checkName()? '': '姓名不能為空不能有特殊符號'
      let checkLineMsg = this.checkLine()? '': 'line不能有特殊字元或空白字元'
      let checkMobileMsg = this.checkMobile()? '': '手機格式錯誤'
      let checkHomePhoneMsg = this.checkPhone('home')? '': '住家電話格式錯誤'
      let checkOfficePhoneMsg = this.checkPhone('office')? '': '公司電話格式錯誤'
      let checkContactInfoMsg = this.checkContactInfoIsAllEmpty()? '聯絡資訊不能全為空': ''
      let toastMsg = [checkNameMsg, checkLineMsg, checkMobileMsg, checkHomePhoneMsg , checkOfficePhoneMsg].filter(msg => {return msg != ''}).join(',')
      
      if(toastMsg == '') {
        let insertData = Object.assign({}, this.form)
        this.loading = true
        addNewCust(this.$store.state.userInfo.id, this.form).then(result => {
          if(result.header && result.header.status && result.header.status === '200'){
            this.$toast.info({title: `${result.header.message}`})
            if(result.body.ser_no){  //如果客戶是無 ID
              console.log("==",result.body)
              // let serNo = result.body.ser_no
              this.updateSerNo(result.body.ser_no)
              this.updateCustID('')
              localStorage.SerNo = result.body.ser_no
              localStorage.CustID = ''
              this.$router.push({path:'/customer'})
            }else{                   //如果客戶有 ID
              this.updateCustID(this.form.identityID)
              this.updateSerNo('')
              localStorage.SerNo = ''
              localStorage.CustID = this.form.identityID
              this.$router.push({path:'/customer'})
            }
          } else {
            if(result.header && result.header.message){
              this.$toast.info({title: `${result.header.message}`})
            }else{
              this.$toast.info({title: `新增客戶失敗`})
            }
          }
              this.loading = false
        })
      } else {
        this.$toast.info({title: toastMsg})  
      }     
    },      
    doReset(){
      this.form.identityID = ''
      this.form.lineid = ''
      this.form.mobile = ''
      this.form.name = ''
      this.form.office_phone['','','']
      this.form.phone = ['','']
    }    
  },
  mounted () {
  }
}
</script>
